import React from 'react';
import { Link } from 'react-router-dom';
import { cx } from '@emotion/css';
import * as styles from './footer.style';
import FooterLogo from '../../assets/images/footer-logo.png';
import TwitterIcon from '../../assets/images/twitter.png';
import InstagramIcon from '../../assets/images/instagram.png';
import FacebookIcon from '../../assets/images/facebook.png';
import YoutubeIcon from '../../assets/images/youtube.png';
import LocationIcon from '../../assets/images/location.png';
import EmailIcon from '../../assets/images/email.png';
import PhoneIcon from '../../assets/images/call.png';

export default function Footer() {
  return (
    <>
      <div className={cx(styles.footerFluid)}>
        <div className={cx(styles.footerFlex)}>
          <div className={cx(styles.colmd3)}>
            <div className={cx(styles.footerLogo)}>
              <img src={FooterLogo} alt="" />
              <p>Let the challenge begin</p>
              {/* <div className={cx(styles.socialIcon)}>
                <Link to="#">
                  <img src={TwitterIcon} alt="" />
                </Link>
                <Link to="#">
                  <img src={InstagramIcon} alt="" />
                </Link>
                <Link to="#">
                  <img src={FacebookIcon} alt="" />
                </Link>
                <Link to="#">
                  <img src={YoutubeIcon} alt="" />
                </Link>
              </div> */}
            </div>
          </div>
          <div className={cx(styles.colmd2)}>
            <div className={cx(styles.footerCols)}>
              <h3>Details Info</h3>
              <ul>
                <li>
                  <Link to="/openevents">Events</Link>
                </li>
                <li>
                  <Link to="/assignments">Challenges</Link>
                </li>
                <li>
                  <Link to="/practiceevents">Practices</Link>
                </li>
                <li>
                  <Link to="/batch">Batches</Link>
                </li>
                <li>
                  <Link to="/terms">Term &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/refund">Refund Policy</Link>
                </li>

              </ul>
            </div>
          </div>
          <div className={cx(styles.colmd3)}>
            <div className={cx(styles.footerCols)}>
              <h3>Contact Info</h3>
              <div className={cx(styles.footerContact)}>
                <li>
                  TunesLogic LLC
                </li>
                <li>
                  <img src={LocationIcon} alt="" />
                  Carmel, Indiana, United States
                </li>
                <li>
                  <img src={EmailIcon} alt="" />
                  <a href='mailto:support@gencoft.com'>support@gencoft.com</a>
                </li>
              </div>
            </div>
          </div>
        </div>

        <div className={cx(styles.copyright)}>
          © Copyright 2025 by Gencoft Technologies.
        </div>
      </div>
    </>
  );
}
